<template>
  <div
    class="image-file-input"
    @dragover.prevent="fileDragged = true"
    @dragleave.prevent="fileDragged = false"
    @drop.prevent="handleFileDrop"
  >
    <label class="image-file-input__label" :class="{ 'image-file-input--dragged': fileDragged }" :for="id">
      <input :id="id" type="file" :accept="accepted.join(', ')" @change="emitChange" />

      <template v-if="file">
        <div class="selected-file">{{ file.name }}</div>
      </template>
      <template v-else>
        <div class="drop-space">
          <font-awesome-icon :icon="['fal', 'cloud-upload']" class="image-file-input__icon" />
          <!-- eslint-disable vue/no-v-html -->
          <span class="d-block" v-html="uploadText"></span>
          <!-- eslint-enable vue/no-v-html -->
          <small>Supported file types: jpg, png</small>
        </div>
      </template>
    </label>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const accepted = ['image/jpeg', 'image/png'];

defineProps({
  file: File,
  id: {
    type: String,
    required: true,
  },
  uploadText: {
    type: String,
    default: 'Drop image here or <u>click</u> to browse',
  },
});

const emit = defineEmits(['change']);

const fileDragged = ref(false);

const emitChange = event => {
  emit('change', event);
};

const handleFileDrop = event => {
  fileDragged.value = false;
  emit('change', event);
};
</script>

<style scoped lang="scss">
.image-file-input__label {
  align-items: center;
  background-color: var(--palette-color-base-white);
  border: 1px dashed var(--palette-color-default-lighten-80);
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  padding: 2rem 1.5rem;
  transition: background-color 0.25s;

  input[type='file'] {
    display: none;
  }
}

.image-file-input--dragged {
  background-color: var(--palette-color-base-white);

  .image-file-input__icon {
    color: var(--palette-color-brand-primary);
  }
}

.image-file-input__icon {
  height: 2rem;
  margin-right: 1rem;
  transition: color -0.25s;
  width: 2rem;
}

.drop-space {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-direction: column;
}

.d-block {
  ::v-deep u {
    color: var(--palette-color-brand-primary);
  }
}

.selected-file {
  font-size: 0.875rem;
  color: var(--palette-color-default);
}
</style>
